const getMaxResidualValue = (equipmentCost, maxResidualValue) => {
  if (maxResidualValue === 0) {
    return equipmentCost;
  }
  return equipmentCost * (maxResidualValue / 100);
};

export default getMaxResidualValue;
